import React, { Suspense } from "react";
import { Input } from "reactstrap";
import "./multi-stop-announce.css";

const PlacesAutocomplete = React.lazy(() =>
  import("../../components/common/PlacesAutocomplete")
);

const Fallback = ({ id, placeholder }) => (
  <Input
    type="text"
    className="lp2-loc-control"
    id={id}
    placeholder={placeholder}
  />
);

/**
 * Uber-style connected location group: a filled container with a pick-up row
 * (dot marker) and a drop-off row (square marker) joined by a vertical line.
 * Reuses the shared (lazy-loaded) PlacesAutocomplete component.
 */
const AddressFields = ({
  onCollection,
  onDelivery,
  highlight,
  initialCollectionAddress = "",
  initialDeliveryAddress = "",
  hideCollection = false,
  deliveryOnlyLabel,
  multiStopHref,
  multiStopTarget,
  multiStopRel,
}) => {
  return (
    <div className="lp2-locations-wrap">
      <div
        className={
          "lp2-locations" +
          (highlight ? " is-highlight" : "") +
          (hideCollection ? " is-locked-pickup" : "")
        }
      >
        {!hideCollection && (
        <div className="lp2-loc-row">
          <span className="lp2-loc-marker lp2-loc-dot" aria-hidden="true" />
          <div className="lp2-loc-input">
            <Suspense
              fallback={
                <Fallback id="lp2-collection" placeholder="Enter pick-up location" />
              }
            >
              <PlacesAutocomplete
                type="text"
                className="lp2-loc-control"
                id="lp2-collection"
                aria-label="Pick up address"
                placeholder="Enter pick-up location"
                initialValue={initialCollectionAddress}
                required
                onPlaceSelected={(place) => {
                  onCollection({
                    lat: place?.geometry?.location?.lat(),
                    lng: place?.geometry?.location?.lng(),
                    address: place?.formatted_address || "",
                  });
                }}
              />
            </Suspense>
          </div>
        </div>
        )}

        <div className="lp2-loc-row">
          <span className="lp2-loc-marker lp2-loc-square" aria-hidden="true" />
          <div className="lp2-loc-input">
            {deliveryOnlyLabel && (
              <label className="lp2-label" htmlFor="lp2-delivery">
                {deliveryOnlyLabel}
              </label>
            )}
            <Suspense
              fallback={
                <Fallback id="lp2-delivery" placeholder="Enter destination" />
              }
            >
              <PlacesAutocomplete
                type="text"
                className="lp2-loc-control"
                id="lp2-delivery"
                aria-label="Drop off address"
                placeholder="Enter destination"
                initialValue={initialDeliveryAddress}
                required
                onPlaceSelected={(place) => {
                  onDelivery({
                    lat: place?.geometry?.location?.lat(),
                    lng: place?.geometry?.location?.lng(),
                    address: place?.formatted_address || "",
                  });
                }}
              />
            </Suspense>
          </div>
        </div>
      </div>

      {multiStopHref ? (
        <p className="lp2-ms-link">
          Need more than one pickup or drop-off?{" "}
          <a href={multiStopHref} target={multiStopTarget} rel={multiStopRel}>
            Use multi-stop booking
          </a>
        </p>
      ) : null}
    </div>
  );
};

export default AddressFields;
